export default __webpack_public_path__ + "images/d19c7eddaa475ef9952679192341462d-boat_small.webp";